/** 当前文件仅用于在APP内打开页面，不用于在H5中打开页面，判断环境放到业务层中 */

import {
  HandlerResultCode,
  AppRouterName,
  OpenWithNewWebViewParams,
  MessageClickType,
  PageControlActionName,
  TMessageDetailAction,
  TAppRouterArguments,
} from "@/shared";
import { isInApp } from "./is";
import { YooFindsChannel } from "./base-flutter-channel";
import { BaseAppChannel } from "./base-app-channel";
import { jumpProductToApp } from "./openApp";

export const openWebViewInApp = async (params: OpenWithNewWebViewParams) => {
  if (isInApp()) {
    const res = await BaseAppChannel.openWithNewWebViewAsync(params.jump_url);
    if (res?.code === HandlerResultCode.Success) return res;
    YooFindsChannel.callYooFindsOpenLink(params);
  }
};

export async function openExternalBrowserInApp(url: string) {
  const res = await BaseAppChannel.openWithExternalBrowserAsync(url);
  if (res?.code === HandlerResultCode.Success) return res;
  YooFindsChannel.callOpenWithExternalBrowser(url);
}

export const openSampleDetailInApp = async (
  args: TAppRouterArguments[AppRouterName.SampleDetail]
) => {
  if (isInApp()) {
    const res = await BaseAppChannel.goAppRouterNameAsync(
      AppRouterName.SampleDetail,
      args
    );
    if (res?.code === HandlerResultCode.Success) return res;
    YooFindsChannel.callYooFindsOpenSampleDetail(args.sample_order_id);
  }
};

export const openVipCenterInApp = async () => {
  if (isInApp()) {
    const res = await BaseAppChannel.goAppRouterNameAsync(
      AppRouterName.VipCenter
    );
    if (res?.code === HandlerResultCode.Success) return res;
    YooFindsChannel.callYooFindsMemberShipPage();
  }
};

export const openHigherCommissionInApp = async () => {
  if (isInApp()) {
    const res = await BaseAppChannel.goAppRouterNameAsync(
      AppRouterName.HigherComm
    );
    if (res?.code === HandlerResultCode.Success) return res;
    YooFindsChannel.callYooFindsOpenHigherCommission();
  }
};

export const openAdTaskDetailInApp = async (
  args: TAppRouterArguments[AppRouterName.AdTaskDetailPage]
) => {
  if (isInApp()) {
    const res = await BaseAppChannel.goAppRouterNameAsync(
      AppRouterName.AdTaskDetailPage,
      args
    );
    if (res?.code === HandlerResultCode.Success) return res;
    YooFindsChannel.callYooFindsAdTask(args?.task_order_id);
  }
};

export const hideTitleBarInApp = async () => {
  if (isInApp()) {
    const res = await BaseAppChannel.hideTitleBarAsync();
    if (res?.code === HandlerResultCode.Success) return res;
  }
};

export const closeWebViewInApp = async () => {
  if (isInApp()) {
    const res = await BaseAppChannel.pageControlAsync(
      PageControlActionName.Close
    );
    if (res?.code === HandlerResultCode.Success) return res;
    YooFindsChannel.callYooFindsCloseWebview();
  }
};

export async function openWalletInApp() {
  if (isInApp()) {
    const res = await BaseAppChannel.goAppRouterNameAsync(
      AppRouterName.Wallet,
      undefined
    );
    if (res?.code === HandlerResultCode.Success) return res;
    YooFindsChannel.callJumpWallet();
  }
}

export const openMessageDetailInApp = (action: TMessageDetailAction) => {
  switch (action.type) {
    case MessageClickType.link:
      openWebViewInApp(action.params);
      break;
    case MessageClickType.sample:
      openSampleDetailInApp({
        sample_order_id: action.params,
      });
      break;
    case MessageClickType.product:
      jumpProductToApp(action.params);
      break;
    case MessageClickType.membership:
      openVipCenterInApp();
      break;
    case MessageClickType.highCommission:
      openHigherCommissionInApp();
      break;
    case MessageClickType.adTaskDetail:
      openAdTaskDetailInApp({
        task_order_id: action.params,
      });
      break;
  }
};

export async function openSampleAuthorizeInApp(link: string) {
  const res = await BaseAppChannel.openSampleAuthorizeAsync(link);
  if (res?.code === HandlerResultCode.Success) return res;
  YooFindsChannel.callOpenSampleAuthorize(link);
}

export async function loginInApp(middleContent?: string) {
  const res = await BaseAppChannel.loginAsync(middleContent);
  if (res) {
    return res;
  }
  YooFindsChannel.callOpenLoginPage();
}

export async function openProductDetailInApp(
  params: TAppRouterArguments[AppRouterName.ProductDetail]
) {
  const res = await BaseAppChannel.goAppRouterNameAsync(
    AppRouterName.ProductDetail,
    params
  );
  if (res?.code === HandlerResultCode.Success) return res;
  YooFindsChannel.callOpenProductDetail(params.hashId, params.appParams);
}
